__turbopack_context__.v({
  "className": "replica_860982f-module__JvkjGG__className",
  "variable": "replica_860982f-module__JvkjGG__variable",
});
